import { render, staticRenderFns } from "./AddClassList.vue?vue&type=template&id=41a71f36&scoped=true&"
import script from "./AddClassList.vue?vue&type=script&lang=js&"
export * from "./AddClassList.vue?vue&type=script&lang=js&"
import style0 from "./AddClassList.vue?vue&type=style&index=0&id=41a71f36&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a71f36",
  null
  
)

export default component.exports